module.exports = __webpack_public_path__ + "static/media/15f-09_Chapa-10-2015-Barra-de-grafito-6B-sobre-papel-90gr-863x596mm.94e7e4e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15f/15f-09_Chapa-10-2015-Barra-de-grafito-6B-sobre-papel-90gr-863x596mm.png
// module id = 182
// module chunks = 0